module.exports = __webpack_public_path__ + "static/media/google_maps_marker.c1345c6c.svg";